module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_short_back.46435559.png";